import { Injectable, inject } from '@angular/core';
import { Firestore, doc, getDoc } from '@angular/fire/firestore';
import { from, map, Observable } from 'rxjs';

/** Reads the staging-only allowlist. The matching Firestore rule allows users
 * to inspect only their own entry; no client can grant access to itself. */
@Injectable({ providedIn: 'root' })
export class StageAccessService {
  private readonly firestore = inject(Firestore);

  isLocked(): Observable<boolean> {
    return from(getDoc(doc(this.firestore, 'stageAccessConfig/enabled'))).pipe(
      map(snapshot => snapshot.exists() && snapshot.data()['enabled'] === true)
    );
  }

  hasAccess(uid: string): Observable<boolean> {
    return from(getDoc(doc(this.firestore, `stageAccess/${uid}`))).pipe(
      map(snapshot => snapshot.exists() && snapshot.data()['enabled'] === true)
    );
  }
}
